// Copyright (c) StrangeBee 2024

export const emptyStringToNull = (data?: Record<string, any>): Record<string, any> =>
    Object.entries({ ...data }).reduce((acc, [key, value]) => {
        if (typeof value === 'string' && value.trim() === '') {
            value = null;
        }
        return {
            ...acc,
            [key]: value,
        };
    }, {});
